import React from 'react';
import config from 'next/config';
import PropTypes from 'prop-types';
import MakeAsyncFunction from 'react-redux-promise-listener';
import { connect } from 'react-redux';
import PaypalButton from '../../../../../01_atoms/Payments/PaypalButton';
import { BACKEND_URL, RG, SD, DEFAULT_COUNTRY_CODE } from '../../../../../../utils/constants';
import {
  filterActiveMethods,
  PAYMENT_MODE,
  PAYMENT_MODE_LIVE,
  PAYPAL_DONATION_PAYLOAD,
  PAYPAL_SUBSCRIPTION_PAYLOAD,
} from '../../../../../../utils/payments';
import { promiseListener } from '../../../../../../store/store';
import unexpectedErrorMessage from '../../../../../../utils/unexpectedErrorMessage';
import {
  donationFormPaymentSuccess,
  donationFormSubmitError,
  donationFormUnLock,
} from '../../../../../../store/Slices/cnet/donationFormSlice';

// Load PayPal's rest credentials.
const {
  publicRuntimeConfig: { PAYPAL_CLIENT_TEST, PAYPAL_CLIENT_LIVE },
} = config();

class DonationPaypal extends React.Component {
  state = {
    isError: false,
  };

  constructor(props) {
    super(props);
    this.onSuccess = this.onSuccess.bind(this);
    this.onError = this.onError.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onSuccess = (orderId) => {
    const { dispatch = () => {} } = this.props;
    dispatch(donationFormPaymentSuccess(orderId));
  };

  onError() {
    const { dispatch = () => {} } = this.props;
    const { isError } = this.state;
    // PayPal error can have multiple layers each of which will trigger onError
    // callback. Ensure we show error on a screen only once.
    if (!isError) {
      dispatch(donationFormUnLock());
      // TODO: Move error message as constant to /utils/constants.js.
      dispatch(
        donationFormSubmitError({
          errorMessage:
            "Sorry, we couldn't complete your donation. Please review your details and try again or select an alternative payment method.",
          subline: unexpectedErrorMessage(),
        }),
      );
      this.setState({ isError: true });
    }
  }

  onCancel = () => {
    const { dispatch = () => {} } = this.props;
    dispatch(donationFormUnLock());
  };

  onClick = () => {
    // Reset error state on click.
    this.setState({ isError: false });
  };

  render() {
    const { visible = true, donationType } = this.props;

    // Find paypal payment method that matches the current payment mode.
    let paypalPaymentMethod;
    filterActiveMethods({
      mode: PAYMENT_MODE,
      donationType,
      region: DEFAULT_COUNTRY_CODE,
    }).forEach((method) => {
      if (method.type && method.type === 'paypal_ec') {
        paypalPaymentMethod = method;
      }
    });

    // Payment method is required to make payments.
    if (!paypalPaymentMethod) {
      return null;
    }

    const style = {
      label: 'paypal',
      size: 'responsive',
      shape: 'pill',
      color: 'blue',
      tagline: false,
    };

    return (
      <MakeAsyncFunction
        // TODO: Replace MakeAsyncFunction with createAsyncThunk
        // from redux-toolkit.
        listener={promiseListener}
        start="donationForm/donationFormSubmit"
        resolve="donationForm/donationFormSubmitSuccess"
        reject="donationForm/donationFormSubmitError"
        // Tell resolver to resolve() the order ID from the redux action.
        getPayload={(action) => action.payload}
      >
        {(onBeforeAuthentication) => (
          <PaypalButton
            client={{
              sandbox: PAYPAL_CLIENT_TEST,
              production: PAYPAL_CLIENT_LIVE,
            }}
            env={PAYMENT_MODE === PAYMENT_MODE_LIVE ? 'production' : 'sandbox'}
            commit={false}
            isSubscription={donationType === RG}
            payload={donationType === RG ? PAYPAL_SUBSCRIPTION_PAYLOAD : PAYPAL_DONATION_PAYLOAD}
            backendURL={BACKEND_URL}
            onSuccess={this.onSuccess}
            onCancel={this.onCancel}
            onError={this.onError}
            onClick={this.onClick}
            onBeforeAuthentication={onBeforeAuthentication}
            paymentGateway={paypalPaymentMethod.id}
            style={style}
            visible={visible}
          />
        )}
      </MakeAsyncFunction>
    );
  }
}

DonationPaypal.propTypes = {
  donationType: PropTypes.oneOf([SD, RG]).isRequired,
  visible: PropTypes.bool,
  dispatch: PropTypes.func,
};

// We have it connected to Redux, to keep the component updated.
// Without the connection redirect to Thank you page won't happen for the multistep checkout.
export default connect()(DonationPaypal);
